import { Box } from "@chakra-ui/react";
import Message from "./Message";
import { useEffect, useRef } from "react";
import MarkdownMessage from "./MarkdownMessage";

export default function MessageList({
    messages,
    currentAssistantMessage,
    currentUserMessage,
    showDialog,
    showCommands,
}) {
    // Inside your component
    const bottomRef = useRef(null);

    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages, currentAssistantMessage, currentUserMessage]);

    if (messages.length === 0) {
        return (
            <Box textAlign="center" color="gray.500" py={8}>
                No messages yet. Start a session to see messages here.
            </Box>
        );
    }

    return (
        <Box display="flex" flexDirection="column" gap={4} mt={4}>
            {messages
                .filter(({ role }) => {
                    return role === "tools" ? showCommands : showDialog;
                })
                .map(({ role, content, type, name, key, call_id }, index) => {
                    if (role === "tools" && type === "function_call") {
                        if (messages.find((message) => key === message.call_id))
                            return null;
                    }
                    return (
                        <Message
                            key={index}
                            role={role}
                            content={content}
                            type={type}
                            name={name}
                        />
                    );
                })}
            {showDialog && currentUserMessage && (
                <Message role="user" content={currentUserMessage} />
            )}
            {showDialog && currentAssistantMessage && (
                <MarkdownMessage
                    isStreaming
                    content={currentAssistantMessage}
                ></MarkdownMessage>
            )}
            <div ref={bottomRef} />
        </Box>
    );
}
